var map = {
	"./background.jpg": 671,
	"./black.png": 837,
	"./brandname.png": 705,
	"./eurofin.png": 1,
	"./gold_product.jpeg": 674,
	"./lab-tested.png": 846,
	"./logowithbackground.png": 258,
	"./logowithoutlogo.png": 993,
	"./logowithwhitebackground.jpg": 111,
	"./mels-shilajit-product.png": 499,
	"./non-gmo.png": 450,
	"./red.png": 654,
	"./sliver_product.jpeg": 395,
	"./snake.png": 771,
	"./vegan.png": 704,
	"./yellow.png": 107
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 811;